import {
  IcCashierVoided,
  IcClosedTicket,
  IcTrash,
  Tabs
} from '@fozito/common-ui';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  flex: 1;
`;

const TicketsLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const shopId = storage.shop_id.get();

  const tabs = [
    {
      key: 'closed',
      label: 'CLOSED TICKETS',
      activeIcon: <IcClosedTicket fill='white' />,
      inactiveIcon: <IcClosedTicket />,
    },
    {
      key: 'voided',
      label: 'VOIDED',
      activeIcon: <IcCashierVoided fill='white' />,
      inactiveIcon: <IcCashierVoided />,
    },
    {
      key: 'deleted',
      label: 'DELETED',
      activeIcon: <IcTrash fill='white' />,
      inactiveIcon: <IcTrash />,
    },
  ];

  const pathToKey: Record<string, string> = {
    [`/store/${shopId}/ticket`]: 'closed',
    [`/store/${shopId}/ticket/voided`]: 'voided',
    [`/store/${shopId}/ticket/deleted`]: 'deleted',
  };

  const keyToPath: Record<string, string> = Object.entries(pathToKey).reduce(
    (acc, [path, key]) => ({
      ...acc,
      [key]: path,
    }),
    {}
  );

  const activeKey = pathToKey[location.pathname];

  const handleTabChange = (key: string) => {
    navigate(keyToPath[key]);
  };

  return (
      <Container>
        {activeKey && (
          <Tabs
            items={tabs}
            activeKey={activeKey}
            onChange={handleTabChange}
            height={50}
            minWidth={200}
          />
        )}
        <Content>
          <Outlet />
        </Content>
      </Container>
  );
};

export default TicketsLayout;
